module.exports = __webpack_public_path__ + "img/city-back.7b956687.svg";